import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import images from '@/images';
import { DEAL_STATUS } from '@/constants/chatConstants';

interface StatusTableDataProps {
  content: {
    status?: string;
  };
}

const StatusTableData: React.FC<StatusTableDataProps> = ({ content }) => {
  const { t } = useTranslation();
  const myDealStatus = content?.status;

  const statusLabel = useMemo(() => {
    switch (myDealStatus) {
      case DEAL_STATUS.ACTIVE:
        return t('myDealStatus.in_progress');
      case DEAL_STATUS.ACCEPTED:
        return t('myDealStatus.accepted');
      case DEAL_STATUS.COMPLETED:
        return t('myDealStatus.completed');
      case DEAL_STATUS.HIDDEN:
        return t('myDealStatus.hidden');
      case DEAL_STATUS.EXPIRED:
        return t('myDealStatus.expired');
      default:
        return '-';
    }
  }, [myDealStatus]);

  const statusIcon = useMemo(() => {
    switch (myDealStatus) {
      case DEAL_STATUS.ACTIVE:
        return <img src={images.clock} alt="in progress" />;
      case DEAL_STATUS.ACCEPTED:
        return <img src={images.checkMarkGreen} alt="accepted" />;
      case DEAL_STATUS.COMPLETED:
        return <img src={images.star_full} alt="completed" />;
      case DEAL_STATUS.HIDDEN:
        return <img src={images.eye_invisible} alt="invisible" />;
      case DEAL_STATUS.EXPIRED:
        return <img src={images.expired} alt="expired" />;
      default:
        return null;
    }
  }, [myDealStatus]);

  if (!myDealStatus) {
    return null;
  }

  return (
    <div className={styles.status}>
      <span className={styles.icon}>{statusIcon}</span>
      <span>{statusLabel}</span>
    </div>
  );
};

export default StatusTableData;
